/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, lines: NonNullable<unknown>, maxLines: NonNullable<unknown> }} Embed_Captions_Too_Many_Lines_TextInputs */

const en_embed_captions_too_many_lines_text = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} has ${i?.lines} lines, but 608 captions only support a maximum of ${i?.maxLines} lines. Please reduce the number of lines before exporting.`)
};

const fr_embed_captions_too_many_lines_text = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'evenement ${i?.index} comporte ${i?.lines} lignes, mais les sous-titres 608 supportent un maximum de ${i?.maxLines} lignes. Veuillez reduire le nombre de lignes avant l'exportation.`)
};

const de_embed_captions_too_many_lines_text = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ereignis ${i?.index} enthält ${i?.lines} Zeilen, aber 608 Untertitel unterstützen maximal ${i?.maxLines} Zeilen. Bitte reduzieren Sie die Zeilenanzahl vor dem Export.`)
};

const it_embed_captions_too_many_lines_text = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'evento ${i?.index} ha ${i?.lines} righe, ma le didascalie 608 supportano solo un massimo di ${i?.maxLines} righe. Ridurre il numero di righe prima di esportare.`)
};

const ru_embed_captions_too_many_lines_text = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index} имеет ${i?.lines} строк, но 608 субтитров поддерживают максимум ${i?.maxLines} строк. Пожалуйста, уменьшите количество строк перед экспортом.`)
};

const es_embed_captions_too_many_lines_text = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El evento ${i?.index} tiene ${i?.lines} líneas, pero los subtítulos 608 solo admiten un máximo de ${i?.maxLines} líneas. Reduzca el número de líneas antes de exportar.`)
};

const zh_cn2_embed_captions_too_many_lines_text = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.index} 有 ${i?.lines} 行，但 608 字幕最多只支持 ${i?.maxLines} 行。请在导出前减少行数。`)
};

const ja_embed_captions_too_many_lines_text = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index} には ${i?.lines} 行ありますが、608 キャプションでは最大 ${i?.maxLines} 行までしかサポートされません。エクスポートする前に行数を減らしてください。`)
};

const hi_embed_captions_too_many_lines_text = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.index} में ${i?.lines} लाइनें हैं, लेकिन 608 कैप्शन अधिकतम ${i?.maxLines} लाइनों का ही समर्थन करते हैं। कृपया निर्यात करने से पहले लाइनों की संख्या कम कर दें।`)
};

const pt_pt2_embed_captions_too_many_lines_text = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O evento ${i?.index} possui ${i?.lines} linhas, mas as legendas 608 suportam no máximo ${i?.maxLines} linhas. Por favor, reduza o número de linhas antes de exportar.`)
};

/**
* | output |
* | --- |
* | "Event {index} has {lines} lines, but 608 captions only support a maximum of {maxLines} lines. Please reduce the number of lines before exporting." |
*
* @param {Embed_Captions_Too_Many_Lines_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_too_many_lines_text = /** @type {((inputs: Embed_Captions_Too_Many_Lines_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Too_Many_Lines_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_too_many_lines_text(inputs)
	if (locale === "de") return de_embed_captions_too_many_lines_text(inputs)
	if (locale === "it") return it_embed_captions_too_many_lines_text(inputs)
	if (locale === "ru") return ru_embed_captions_too_many_lines_text(inputs)
	if (locale === "es") return es_embed_captions_too_many_lines_text(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_too_many_lines_text(inputs)
	if (locale === "ja") return ja_embed_captions_too_many_lines_text(inputs)
	if (locale === "hi") return hi_embed_captions_too_many_lines_text(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_too_many_lines_text(inputs)
	return en_embed_captions_too_many_lines_text(inputs)
});